export const COMPANY_POLICIES_SET_LOADING = 'COMPANY_POLICIES/SET_LOADING';
export const COMPANY_POLICIES_SET_ERROR = 'COMPANY_POLICIES/SET_ERROR';
export const COMPANY_POLICIES_SET_POLICIES = 'COMPANY_POLICIES/SET_POLICIES';

export const COMPANY_POLICIES_FETCH_POLICIES =
  'COMPANY_POLICIES/FETCH_POLICIES';

export const COMPANY_POLICIES_GET_POLICIES = 'COMPANY_POLICIES/GET_POLICIES';
export const COMPANY_POLICIES_GET_LOADING = 'COMPANY_POLICIES/GET_LOADING';
export const COMPANY_POLICIES_GET_ERROR = 'COMPANY_POLICIES/GET_ERROR';
